import React, { useState } from "react";
import Navbar from "../global/Navbar";
import Otp from "../components/Login/Otp";
import Password from "../components/Login/Password";
import banner from "../assets/image.png"

export const SignIn = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [modal, setModel] = useState("otp");
  return (
    <div className=" flex flex-col bg-[#101e2b]">
      <Navbar isFixed={isFixed} />
      <div className="w-full flex justify-center items-center pb-[5rem]">
        <div className="container flex lg:flex-row flex-col items-center justify-center mt-[5rem]">
       
          <div className="lg:w-1/2 w-full  flex flex-col justify-center items-center lg:justify-start lg:items-start gap-4">
            <h3 className="sm:text-4xl text-2xl text-white font-bold">
              Sign in to your account
            </h3>
            <div className="flex gap-4 mt-4 border-b-2 border-[#22BEFF33]  w-[80%] ">
              <button
                className={`text-base font-medium text-[#e6eaec] hover:border-b-2 hover:border-[#22BEFF] hover:text-[#22BEFF] pb-3 transition-all ease-linear delay-100 cursor-pointer ${
                  modal === "otp" &&
                  "border-b-2 border-[#22BEFF] text-[#22BEFF]"
                }`}
                onClick={() => setModel("otp")}
              >
                Sign in with OTP
              </button>
              <button
                className={`text-base font-medium text-[#e6eaec] hover:border-b-2 hover:border-[#22BEFF] hover:text-[#22BEFF] pb-3 cursor-pointer ${
                  modal === "password" &&
                  "border-b-2 border-[#22BEFF] text-[#22BEFF]"
                }`}
                onClick={() => setModel("password")}
              >
                Sign in with Password
              </button>
            </div>

            <div className="w-[80%] mt-4 lg:mb-0 mb-[2rem]">
              {modal === "otp" ? <Otp /> : <Password />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
